import React from "react";
import Button from "../../../framework/Button/Button";
import AcquireWebComponent from "../../../framework/MaterialUI/index";
import "./add-campaign.css";
import Checkbox from "material-ui/Checkbox";
import AddCampaignDialog from "./AddCampaignDialog";
import { FullRow } from "../../../framework/Grid";
import DeploymentCampaigns from "./deploymentCampaigns";
import map from "lodash/map";
import Dialog from "material-ui/Dialog";
import filter from "lodash/filter";
import isEmpty from "lodash/isEmpty";

/**
 * @property title {string}
 * @property ifHasCampaigns {boolean}
 */
class AddCampaign extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: props.openDialog,
      emailReportType: "delivered",
      emailReportDelivered: props.parentCampaignDetail
        ? props.parentCampaignDetail.emailReportDelivered
        : true,
      emailReportDistinctIndividuals: props.parentCampaignDetail
        ? props.parentCampaignDetail.emailReportDistinctIndividuals
        : undefined,
      openDelConfirm: false,
      removeCampaignId: undefined,
      removeDeployName: undefined,
      openDeploymentDialog: false,
      openDelDeploymentDialog: false,
      deployNameError: undefined,
    };
    if (props.legacy && !props.viewMode) {
      props.addDeployment("default", props.title);
    }
  }
  onAddDeploymentBtnClick(e) {
    e.preventDefault();
    this.setState({
      openDeploymentDialog: true,
    });
  }
  onAddSegmentBtnClick(e) {
    e.preventDefault();
    this.props.addDeployment("default", this.props.title);
  }
  onDevploymentDialogClose(e) {
    e.preventDefault();
    this.setState({
      openDeploymentDialog: false,
    });
  }
  onAddCampaignBtnClick(e) {
    e.preventDefault();
    this.props.onClickAddCampaign(this.props.startDate, this.props.endDate);
    this.setState({
      openDialog: true,
    });
  }
  onRequestClose() {
    this.setState({
      openDialog: false,
    });
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.viewMode !== this.props.viewMode &&
      !nextProps.viewMode &&
      nextProps.legacy &&
      isEmpty(nextProps.deploymentCampaigns)
    ) {
      nextProps.addDeployment("default", nextProps.title);
    }
  }
  applyCampaignChange(campaignIds) {
    this.props.onApplyCampaignChanges(
      this.props.title.toLowerCase(),
      campaignIds,
    );
  }
  applyDeploymentChange(campaignIds, deployName) {
    this.props.onApplyCampaignChanges(
      this.props.title.toLowerCase(),
      deployName,
      campaignIds,
    );
  }

  removeCampaignId(id, name) {
    this.setState({
      openDelConfirm: true,
      removeCampaignId: id,
      removeDeployName: name,
    });
  }

  onDelDeployment(name) {
    this.setState({
      openDelDeploymentDialog: true,
      removeDeployName: name,
    });
  }

  closeConfirm(e) {
    e.preventDefault();
    this.setState({ openDelConfirm: false });
  }

  closeConfirmDeployment(e) {
    e.preventDefault();
    this.setState({ openDelDeploymentDialog: false });
  }

  closeDeployConfirm(e) {
    e.preventDefault();
    this.setState({
      openDeploymentDialog: false,
      deployNameError: undefined,
    });
  }
  confirmRemoveDeployment(e) {
    e.preventDefault();
    this.props.removeDeployment(
      this.state.removeDeployName,
      this.props.title.toLowerCase(),
    );
    this.setState({
      openDelDeploymentDialog: false,
      removeDeployName: undefined,
    });
  }

  confirmRemove(e) {
    e.preventDefault();
    if (this.state.removeCampaignId) {
      const cids = [];
      /*
      map(this.props.selectedCampaigns, (sltCampaign)=>{
        if (sltCampaign.id !== this.state.removeCampaignId)
          cids.push(sltCampaign.id)
      })*/
      map(this.props.deploymentCampaigns, campaign => {
        if (campaign.name === this.state.removeDeployName) {
          map(campaign.channelCampaigns, channelCampaign => {
            if (
              parseInt(channelCampaign.id, 10) !==
              parseInt(this.state.removeCampaignId, 10)
            )
              cids.push(channelCampaign.id);
          });
        }
      });
      /*
      if (this.props.parentCampaignDetail) {
        map(this.props.parentCampaignDetail.channelCampaigns, (emailCampaign)=>{
          if (emailCampaign.id !== this.state.removeCampaignId)
            cids.push(emailCampaign.id)
        })
      }*/
      this.props.onApplyCampaignChanges(
        this.props.title.toLowerCase(),
        this.state.removeDeployName,
        cids,
      );
    }
    this.setState({ openDelConfirm: false });
  }

  confirmAddDeployment(e) {
    e.preventDefault();
    const deployName = this.refs.deployName.value.trim();
    const result = filter(this.props.deploymentCampaigns, campaign => {
      return campaign.name === deployName;
    });
    if (result.length > 0 || deployName === "") {
      this.setState({
        deployNameError:
          deployName === ""
            ? "Deployment name could not be empty"
            : "Duplicate deployment name, please update",
      });
    } else {
      this.props.addDeployment(this.refs.deployName.value, this.props.title);
      this.setState({
        openDeploymentDialog: false,
        deployNameError: "",
      });
    }
  }

  onEmailReportDeliveredCheck() {
    const val = !this.state.emailReportDelivered;
    this.setState({
      emailReportDelivered: val,
    });
    this.props.setEmailReportDelivered(val);
  }

  onEmailReportDistinctCheck() {
    const val = !this.state.emailReportDistinctIndividuals;
    this.setState({
      emailReportDistinctIndividuals: val,
    });
    this.props.setEmailReportDistinct(val);
  }

  getReportOption() {
    const { parentCampaignDetail } = this.props;
    if (this.props.viewMode) {
      return (
        <div
          style={{ marginLeft: "30%", marginTop: "-18px", minHeight: "25px" }}
        >
          {parentCampaignDetail && parentCampaignDetail.emailReportDelivered && (
            <p className="no-margin-top" style={{ fontSize: "16px" }}>
              Delivered
            </p>
          )}
          {parentCampaignDetail &&
            parentCampaignDetail.emailReportDistinctIndividuals && (
              <p className="no-margin-top" style={{ fontSize: "16px" }}>
                Distinct Individuals
              </p>
            )}
        </div>
      );
    } else {
      return (
        <div
          style={{ display: "inline-block", marginLeft: "18%", width: "300px" }}
        >
          <Checkbox
            label={"Delivered"}
            checked={this.state.emailReportDelivered}
            onCheck={this.onEmailReportDeliveredCheck.bind(this)}
          />
          <Checkbox
            label={"Distinct Individuals"}
            checked={this.state.emailReportDistinctIndividuals}
            onCheck={this.onEmailReportDistinctCheck.bind(this)}
          />
          {!this.state.emailReportDelivered &&
            !this.state.emailReportDistinctIndividuals && (
              <div style={{ color: "#FF0000", marginBottom: "10px" }}>
                <i className="icon-warning2 pr-10"></i>One reporting option must
                be checked to save
              </div>
            )}
        </div>
        /*
        <RadioButtonGroup style={{paddingLeft:"32%"}} name="reportType" 
        valueSelected={this.state.emailReportType}
        onChange={(e, value) => this.handleEmailReportTypeChange(e, value)}>
        <RadioButton value={"delivered"} label="Delivered" 
          iconStyle={{fill: 'black', width: '20px', height: '20px'}}/>
        <RadioButton value={"distinct"} label="Distinct Individuals" 
          iconStyle={{fill: 'black', width: '20px', height: '20px'}}/>
      </RadioButtonGroup>*/
      );
    }
  }
  render() {
    const campaigns = this.props.parentCampaignDetail
      ? filter(this.props.parentCampaignDetail.channelCampaigns, campaign => {
          return (
            campaign.channel.toLowerCase() === this.props.title.toLowerCase()
          );
        })
      : [];
    const dialogTitle =
      this.props.title === "SOCIAL"
        ? "FACEBOOK"
        : this.props.title === "DISPLAY"
        ? "Google Ads"
        : this.props.title;
    return (
      <div className="add-campaign">
        {this.props.showReportOptions ? (
          <div>
            <h2
              className="no-margin-bottom no-border-bottom"
              style={{ fontSize: "24px" }}
            >
              {this.props.title}
            </h2>
            <div
              style={{
                fontWeight: "bold",
                float: this.props.viewMode ? "none" : "left",
              }}
            >
              Reporting Options
            </div>
            {this.getReportOption()}
          </div>
        ) : (
          <h2 className="no-margin-bottom" style={{ fontSize: "24px" }}>
            {this.props.title}
          </h2>
        )}
        {this.props.children}
        {
          /*
          (this.props.selectedCampaigns &&  this.props.selectedCampaigns.length > 0) ?
            (
              <ChannelCampaignsTable tableHeaderArr={
                [
                  {label: 'Campaign Name', value: 0},
                  {label: 'Campaign ID', value:1},
                  {label: 'Campaign Start Date', value: 2},
                  {label: 'Campaign End Date', value: 3},
                  {label: 'Status', value: 4},
                  {label: '', value:5}
                ]
              } activeIndex={0} bodyDataArr={this.props.selectedCampaigns} showSelectBox={false}
              bodyDataKey={['select','name', 'campaignId','startDate','endDate','status']}
              tableHeaderWidthStyle={
                [ '32%', '18%', '15%', '14.5%', '14%']
              } showDelBtn={!this.props.viewMode} removeCampaignId={this.removeCampaignId.bind(this)}
              />
            ) : (
              <section className="no-data">
                No deployment have been added.
              </section>
            ) */
          <DeploymentCampaigns
            onClickAddSegment={() => {
              this.props.onClickAddCampaign(
                this.props.startDate,
                this.props.endDate,
              );
            }}
            onApplyCampaignChanges={this.applyDeploymentChange.bind(this)}
            campaigns={this.props.deploymentCampaigns}
            dialogTitle={dialogTitle}
            parentCampaignDetail={this.props.parentCampaignDetail}
            title={this.props.title}
            channelCampaigns={this.props.channelCampaigns}
            campaignStatus={
              this.props.parentCampaignDetail
                ? this.props.parentCampaignDetail.status
                : "Draft"
            }
            selectCampaignIds={this.props.prevSelectCampaignIds}
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            removeCampaignId={this.removeCampaignId.bind(this)}
            onDelDeployment={this.onDelDeployment.bind(this)}
            viewMode={this.props.viewMode}
            legacy={this.props.legacy}
          />
        }
        {this.props.viewMode === false && (
          <div className="add-btn clearfix">
            {!this.props.legacy && (
              <Button
                title="Add Deployment"
                disabled={
                  this.props.deploymentCampaigns &&
                  this.props.deploymentCampaigns.length >= 5
                }
                handleClick={this.onAddDeploymentBtnClick.bind(this)}
              />
            )}
          </div>
        )}
        <AddCampaignDialog
          open={this.state.openDialog}
          title={dialogTitle}
          applyChange={this.applyCampaignChange.bind(this)}
          onRequestClose={this.onRequestClose.bind(this)}
          channelCampaigns={this.props.channelCampaigns}
          campaignName={this.props.campaignName}
          emailCampaigns={campaigns}
          channelType={this.props.title.toLowerCase()}
          campaignStatus={
            this.props.parentCampaignDetail
              ? this.props.parentCampaignDetail.status
              : "Draft"
          }
          selectCampaignIds={this.props.prevSelectCampaignIds}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
        />
        <Dialog
          title=""
          open={this.state.openDelConfirm}
          onRequestClose={this.props.onRequestClose}
          bodyStyle={{
            color: "#000",
            fontWeight: "bold",
            fontSize: "16px",
            paddingTop: "0px",
            paddingBottom: "0px",
            textAlign: "center",
          }}
          contentStyle={{ width: "482px", maxWidth: "482px" }}
          titleStyle={{ display: "none" }}
          actionsContainerStyle={{ display: "none" }}
        >
          <FullRow className="no-padding-left no-padding-right no-padding-bottom no-margin-bottom">
            Are you sure you would like to remove this segment?
          </FullRow>
          <FullRow className="no-margin-bottom pt-20">
            <a
              className="btn btn-aa-info mr-20 "
              onClick={this.closeConfirm.bind(this)}
              style={{
                color: "#000",
                fontSize: "16px !important",
                textTransform: "capitalize",
              }}
            >
              Cancel
            </a>
            <a
              className="btn btn-default btn-aa-warning"
              onClick={this.confirmRemove.bind(this)}
              style={{
                fontSize: "16p !importantx",
                textTransform: "capitalize",
              }}
            >
              Remove Segment
            </a>
          </FullRow>
        </Dialog>
        <Dialog
          title=""
          open={this.state.openDelDeploymentDialog}
          onRequestClose={this.props.onRequestClose}
          bodyStyle={{
            color: "#000",
            fontWeight: "bold",
            fontSize: "16px",
            paddingTop: "0px",
            paddingBottom: "0px",
            textAlign: "center",
          }}
          contentStyle={{ width: "482px", maxWidth: "482px" }}
          titleStyle={{ display: "none" }}
          actionsContainerStyle={{ display: "none" }}
        >
          <FullRow className="no-padding-left no-padding-right no-padding-bottom no-margin-bottom">
            Are you sure you would like to remove this deployment?
          </FullRow>
          <FullRow className="no-margin-bottom pt-20">
            <a
              className="btn btn-aa-info mr-20 "
              onClick={this.closeConfirmDeployment.bind(this)}
              style={{
                color: "#000",
                fontSize: "16px !important",
                textTransform: "capitalize",
              }}
            >
              Cancel
            </a>
            <a
              className="btn btn-default btn-aa-warning"
              onClick={this.confirmRemoveDeployment.bind(this)}
              style={{
                fontSize: "16px !important",
                textTransform: "capitalize",
              }}
            >
              Remove Deployment
            </a>
          </FullRow>
        </Dialog>
        <Dialog
          title=""
          open={this.state.openDeploymentDialog}
          onRequestClose={this.onDevploymentDialogClose.bind(this)}
          bodyStyle={{
            color: "#000",
            fontSize: "16px",
            paddingTop: "0px",
            paddingBottom: "0px",
          }}
          contentStyle={{ width: "482px", maxWidth: "482px" }}
          titleStyle={{ display: "none" }}
          actionsContainerStyle={{ display: "none" }}
        >
          <FullRow
            style={{ fontSize: "14px" }}
            className="no-padding-left no-padding-right no-padding-bottom no-margin-bottom"
          >
            <div
              style={{
                fontWeight: "bold",
                marginBottom: "15px",
                fontSize: "16px",
                textTransform: "capitalize",
              }}
            >
              Add {this.props.title.toLowerCase()} Deployment
            </div>
            <span>
              Deployment
              {this.props.deploymentCampaigns
                ? this.props.deploymentCampaigns.length + 1
                : "1"}
            </span>
            <input
              ref={"deployName"}
              className="p-5 light-grey-border"
              style={{ marginLeft: "20px", width: "330px" }}
              maxLength="100"
            />
            <div style={{ color: "#FF0000", fontSize: "12px" }}>
              {this.state.deployNameError}
            </div>
          </FullRow>
          <FullRow
            style={{
              textAlign: "right",
              paddingRight: "0px",
              paddingBottom: "10px",
            }}
          >
            <a
              className="btn btn-aa-info mr-20 btn-aa-claritas-info "
              onClick={this.closeDeployConfirm.bind(this)}
              style={{ color: "#000" }}
            >
              Cancel
            </a>
            <a
              className="btn btn-default btn-aa-default btn-aa-claritas"
              onClick={this.confirmAddDeployment.bind(this)}
            >
              Add Deployment
            </a>
          </FullRow>
        </Dialog>
      </div>
    );
  }
}

export default AddCampaign;

AddCampaign.defaultProps = {
  openDialog: false,
  title: "title",
  ifHasCampaigns: false,
  channelCampaigns: [],
  viewMode: false,
  showReportOptions: false,
  legacy: false,
};



// WEBPACK FOOTER //
// ./src/components/Campaigns/CreateCampaigns/AddCampaign/AddCampaign.jsx